import FormattedMessage from 'I18n/components/FormattedMessage';
import Raven from 'raven-js';
import { useCallback } from 'react';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { useDeleteConversationMutation, useRenameConversationMutation } from '../../__generated__/chirp/com/hubspot/breeze/engine/rpc/BreezeEngineConversationsService.hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export const useConversationMutations = ({
  patch,
  remove,
  restore,
  onActiveDeleted,
  activeConversationId
}) => {
  const [deleteMutation] = useDeleteConversationMutation();
  const [renameMutation] = useRenameConversationMutation();
  const renameConversation = useCallback(async (row, newTitle) => {
    const previousTitle = row.title;
    patch(row.conversationId, {
      title: newTitle
    });
    try {
      await renameMutation({
        variables: {
          conversationId: row.conversationId,
          title: newTitle
        }
      });
    } catch (err) {
      patch(row.conversationId, {
        title: previousTitle
      });
      FloatingAlertStore.addAlert({
        type: 'danger',
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-ai-assistant.drawer.toast.renameError"
        }),
        timeout: 5000
      });
      Raven.captureException(err instanceof Error ? err : new Error(String(err)));
    }
  }, [patch, renameMutation]);
  const deleteConversation = useCallback(async (row, index) => {
    const conversationId = row.conversationId;
    remove(conversationId);
    if (activeConversationId !== null && activeConversationId !== undefined && activeConversationId === conversationId && onActiveDeleted) {
      onActiveDeleted(conversationId);
    }
    try {
      await deleteMutation({
        variables: {
          conversationId
        }
      });
      FloatingAlertStore.addAlert({
        type: 'info',
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-ai-assistant.drawer.toast.deleted"
        }),
        timeout: 5000
      });
    } catch (err) {
      restore(row, index);
      FloatingAlertStore.addAlert({
        type: 'danger',
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-ai-assistant.drawer.toast.deleteError"
        }),
        timeout: 5000
      });
      Raven.captureException(err instanceof Error ? err : new Error(String(err)));
    }
  }, [activeConversationId, deleteMutation, onActiveDeleted, remove, restore]);
  return {
    renameConversation,
    deleteConversation
  };
};